<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col- col-12">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-12 text-xl-right text-lg-right text-md-right text-left" ngClass.sm="mb-1">
        <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL' | translate" placement="top" class="cursor-pointer text-primary">{{ "DONT_KNOW_HOW_TO_DO" | translate }}</span>
      </div>
    </div>

    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div class="row">
          <div ngClass.sm="col-12 mb-1" ngClass.md="col-12 mb-1" ngClass.xl="col-3" *ngIf="!notificationToSetAsRead || notificationToSetAsRead.length < 1">
            <label for="search" class="d-flex align-items-center mb-0">
              <input
                [(ngModel)]="searchKeyword"
                (ngModelChange)="filterNotifications()"
                type="search"
                class="form-control"
                id="search"
                [placeholder]="'SEARCH_NOTIFICATION' | translate"
                *ngIf="!notificationToSetAsRead || notificationToSetAsRead.length < 1"
              />
            </label>
          </div>
          <div ngClass.sm="col-12 mb-1" ngClass.md="col-12 mb-1" ngClass.xl="col-3" *ngIf="!notificationToSetAsRead || notificationToSetAsRead.length < 1">
            <label class="d-flex align-items-center mb-0">
              <select [(ngModel)]="selectedCategory" (ngModelChange)="filterNotifications()" class="form-control">
                <option selected disabled value="all">{{ "CATEGORY" | translate }}</option>
                <option value="all">{{ "ALL" | translate }}</option>
                ---
                <option *ngFor="let category of categories">{{ category.name }}</option>
              </select>
            </label>
          </div>
          <div *ngIf="!notificationToSetAsRead || notificationToSetAsRead.length < 1" ngClass.sm="col-12 mb-1" ngClass.md="col-12 mb-1" ngClass.xl="col-4">
            <ng-select [searchable]="false" [clearable]="false" [(ngModel)]="filterRead" (ngModelChange)="changeReadStatus()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 d-block pr-2">{{ "SHOW_ONLY" | translate }} : {{ (filterRead == 0 ? "NEW_NOTIFICATIONS" : "OLD_NOTIFICATIONS") | translate }}</span>
              </ng-template>
              <ng-option value="0"
                ><span class="font-small-4">{{ "NEW_NOTIFICATIONS" | translate }}</span></ng-option
              >
              <ng-option value="1"
                ><span class="font-small-4">{{ "OLD_NOTIFICATIONS" | translate }}</span></ng-option
              >
            </ng-select>
          </div>
          <div ngClass.xl="d-flex align-items-center" ngClass.md="col-12 d-flex" ngClass.sm="mx-1 mb-1" *ngIf="notificationToSetAsRead">
            <button
              (click)="selectAllNotification(true)"
              *ngIf="notificationToSetAsRead && notificationToSetAsRead.length > 0 && notificationToSetAsRead.length !== notificationsList.length"
              type="button"
              class="btn btn-outline-primary"
              ngClass.sm="col-12 mb-1"
              ngClass.md="m-1"
              ngClass.xl="ml-1"
            >
              {{ "SELECT_ALL" | translate }}
            </button>
            <button
              (click)="selectAllNotification(false)"
              *ngIf="notificationToSetAsRead && notificationToSetAsRead.length > 0 && notificationsList && notificationsList.length > 0 && notificationToSetAsRead.length === notificationsList.length"
              type="button"
              class="btn btn-outline-primary"
              ngClass.sm="col-12 mb-1"
              ngClass.md="mr-1 my-1"
            >
              {{ "DESELECT_ALL" | translate }}
            </button>
            <button
              (click)="setNotificationsAsReaded()"
              *ngIf="notificationToSetAsRead && notificationToSetAsRead.length > 0"
              type="button"
              class="btn btn-outline-primary"
              ngClass.xl="ml-1"
              ngClass.sm="col-12"
              ngClass.md="my-1"
            >
              {{ notificationToSetAsRead && notificationToSetAsRead.length === 1 ? ("SET_NOTIFICATION_AS_READ" | translate) : ("SET_NOTIFICATIONS_AS_READ" | translate) }}
            </button>
          </div>
          <div ngClass.xl="col-2" ngClass.sm="d-none" ngClass.md="d-none" *ngIf="!notificationToSetAsRead || notificationToSetAsRead.length < 1">
            <label class="d-flex align-items-center ml-5 mb-0"
              >{{ "SHOW" | translate }}
              <select [(ngModel)]="pageSize" class="form-control ml-075 pr-3">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <div class="border-bottom pt-1 pb-3 px-2" *ngIf="notificationLoaded && filteredNotifications.length < 1">
        <div class="font-medium-1">{{ "YOU_HAVENOT_NOTIFICATION" | translate }}</div>
      </div>
      <div id="notifications-list">
        <div
          class="border-bottom cursor-pointer py-1"
          [ngClass]="communication.read ? '' : 'new-notification'"
          [id]="'notification-' + communication.id"
          *ngFor="let communication of filteredNotifications | slice: (pageBasicText - 1) * pageSize : pageBasicText * pageSize"
        >
          <div class="row pl-1 pr-1">
            <div class="col-12 {{ !communication.read ? 'd-flex' : null }}">
              <div *ngIf="!communication.read" class="mr-05 custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input todo-checkbox"
                  id="customCheck{{ communication.id }}"
                  [checked]="notificationToSetAsRead.includes(communication.id)"
                  (click)="toggleToNotificationsToRead(communication.id)"
                />
                <label class="custom-control-label" for="customCheck{{ communication.id }}"></label>
              </div>
              <div (click)="modalOpen(openNotification, communication.id)" class="row flex-basis-100">
                <div ngClass.xl="col-10" ngClass.md="col-12 order-2 mt-025" ngClass.sm="col-12 order-2 mt-025">
                  <h3 class="mb-025 font-medium-2">{{ communication.title }}</h3>
                  <div *ngIf="communication.text" [innerHTML]="_utilService.stripHTML(communication.text)" class="mt-025 text-break-line-1 font-small-3"></div>
                </div>
                <div ngClass.xl="col-2 text-right" ngClass.md="col-12 d-flex justify-content-between order-1" ngClass.sm="col-12 d-flex justify-content-between order-1">
                  <div class="badge badge-light-primary profile-badge mb-025">
                    <small>{{ communication.category }}</small>
                  </div>
                  <small class="text-end d-block mt-025">{{ _utilService.formatDate(communication.send_date, "DD/MM/YYYY") }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </core-card>
    <div class="row">
      <div class="col-12 d-flex" ngClass.xl="justify-content-end" ngClass.sm="justify-content-center" ngClass.md="justify-content-center">
        <ngb-pagination
          [pageSize]="pageSize"
          [collectionSize]="filteredNotifications.length"
          [(page)]="pageBasicText"
          [ellipses]="false"
          *ngIf="filteredNotifications && filteredNotifications.length > 0"
          aria-label="Custom pagination"
          [maxSize]="5"
        >
          <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="'18'" [class]="'font-weight-bolder page-item'"></span> </ng-template>
          <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="'18'" [class]="'font-weight-bolder page-item'"></span> </ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #openNotification let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="row">
      <div class="col-7">
        <h3 class="mb-05 p-0">{{ selectedCommunication.title }}</h3>
      </div>
      <div class="col-5 text-right">
        <div class="badge badge-light-primary text-wrap profile-badge mb-05">
          <small>{{ selectedCommunication.category }}</small>
        </div>
        <br />
        <span class="font-small-3">{{ selectedCommunication.send_date.format("DD/MM/YYYY") }}</span>
      </div>
    </div>
    <div class="mt-3 mb-05" id="notification-content" [innerHTML]="selectedCommunication.text"></div>
    <div *ngIf="selectedCommunication.related_url && selectedCommunication.related_url.length > 0" class="mb-1">
      <a [href]="selectedCommunication.related_url">{{ "VIEW" | translate }}</a>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button (click)="modalClose()" type="button" class="btn btn-primary w-150" rippleEffect>
      {{ "ALERT.BTN_CLOSE" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal -->
